import { Divider, Skeleton } from '@mui/material';
import { ProfileEditorWrapper } from '../common';
import { BasicAccountSettingsBox } from './basic-account-settings-box';
import { ChangePasswordBox } from './change-password-box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LoadingAccountSettings = function LoadingAccountSettings() {
  return /*#__PURE__*/_jsxs(ProfileEditorWrapper, {
    "data-element": "ProfileEditorWrapper",
    "data-component": "LoadingAccountSettings",
    "data-source-file": "loading.tsx",
    children: [/*#__PURE__*/_jsxs(BasicAccountSettingsBox, {
      "data-element": "BasicAccountSettingsBox",
      "data-component": "LoadingAccountSettings",
      "data-source-file": "loading.tsx",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        width: "100%",
        height: 80,
        "data-element": "Skeleton",
        "data-component": "LoadingAccountSettings",
        "data-source-file": "loading.tsx"
      }), /*#__PURE__*/_jsx(Skeleton, {
        width: "100%",
        height: 80,
        "data-element": "Skeleton",
        "data-source-file": "loading.tsx"
      })]
    }), /*#__PURE__*/_jsx(Divider, {
      "data-element": "Divider",
      "data-source-file": "loading.tsx"
    }), /*#__PURE__*/_jsxs(ChangePasswordBox, {
      "data-element": "ChangePasswordBox",
      "data-source-file": "loading.tsx",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        width: "100%",
        height: 80,
        "data-element": "Skeleton",
        "data-source-file": "loading.tsx"
      }), /*#__PURE__*/_jsx(Skeleton, {
        width: "100%",
        height: 80,
        "data-element": "Skeleton",
        "data-source-file": "loading.tsx"
      })]
    })]
  });
};

export default LoadingAccountSettings;